<template>
  <div
    class="bg-[#F2F3F8] border-2 border-white rounded-lg shadow-[0px_10px_12px_#4d64b247] p-8"
  >
    <div class="mb-8 font-bold text-center text-lg laptop:text-2xl">
      {{ data.title }}
    </div>

    <div
      class="flex flex-col laptop:flex-row w-full justify-between rounded-2xl"
    >
      <div
        class="w-full laptop:w-2/3 flex flex-col flex-start px-1 laptop:px-10 mt-6 order-2 laptop:order-1 laptop:mt-0"
      >
        <div class="flex mb-4" v-for="item in data.options" :key="item.id">
          <div v-if="showTik" class="me-1">
            <IconLightTik class="stroke-blue-700 scale-100 ml-2 h-6 mt-[7px]" />
          </div>
          <p class="laptop:!leading-9 text-sm laptop:text-base" v-html="item.text" />
        </div>
      </div>
      <div class="w-full laptop:w-1/3 order-1 laptop:order-2">
        <NuxtImg
          sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
          width="1000"
          height="1000"
          loading="lazy"
          format="webp"
          quality="100"
          class="w-full"
          :src="data.img"
          :alt="data.title"
        />
      </div>
    </div>

    <!-- <div class="just-mobile cursor-pointer">
      <div class="flex justify-center pt-6">
        <button
          class="flex bg-white p-2 font-semibold rounded-3xl transition-all duration-300 ease-in-out"
          @click.prevent="isOpen = true"
          :aria-expanded="isOpen"
          :class="isOpen ? 'opacity-0' : ''"
        >
          <div class="w-3 h-3 mx-1 rounded-full bg-blue-700"></div>
          <div class="w-3 h-3 mx-1 rounded-full bg-blue-700"></div>
          <div class="w-3 h-3 mx-1 rounded-full bg-blue-700"></div>
        </button>
      </div>
      <div
        class="grid font-bold text-sm text-slate-600 overflow-hidden transition-all duration-300 ease-in-out"
        :class="
          isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        "
      >
        <div class="overflow-hidden">
          <div
            class="text-blue-700 opacity-70 text-start text-xs laptop:text-sm mb-9 text-justify"
          >
            <div class="w-full flex flex-col flex-start">
              <div
                class="flex mb-4"
                v-for="item in data.options"
                :key="item.id"
              >
                <div class="me-1">
                  <IconLightTik
                    class="stroke-blue-700 scale-100 ml-2 h-4 mt-2"
                  />
                </div>
                <p class="!leading-6">{{ item.text }}</p>
              </div>
            </div>
            <div class="flex justify-center" @click="isOpen = false">
              <IconArrowDown
                class="stroke-blue-700 scale-100 ml-2 h-4 mt-2 rotate-180"
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
defineProps({
  data: Object,
  showTik: Boolean
});

const isOpen = ref(false);
</script>
